(function () {
    'use strict';

    angular
        .module('app.widgets')
        .directive('spCountBox', spCountBox);

    /* @ngInject */
    spCountBox.$inject = ['$parse'];
    function spCountBox($parse) {
        //Usage:
        //<div sp-count-box icon="fa-bell" itemCount="vm.alertCount" state="alert.list" viewDetailsText="View Details"></div>
        var directive = {
            scope: {
                'icon': '@',
                'count': '@',
                'state': '@',
                'footer': '@',
                'title': '@',
                'color': '@',
                'backgroundcolor': '@'
            },
            template: 
    '<div class="col-xs-3 text-center" style="min-width:150px;">' +
                '<span class="pull-right panel-{{color}}" style="padding-right:.3em;">' +
                '<span ng-show="count < 0" class="background-{{backgroundcolor}}" style="color:white"><i class="fa fa-spin fa-spinner"></i></span>' +
                '<span ng-hide="count < 0" class="background-{{backgroundcolor}}" style="color:white">{{count}}</span>' +
                '<span ng-show="count <= 0" class="background-{{backgroundcolor}}" style="color:white">&nbsp;</span>' +
                '</span>' +
                '<a ui-sref="{{state}}">' +
                '<div class="panel panel-{{color}}">' +
                '<div class="panel-heading">' +
                '<div class="row">' +
                '<div class="col-xs-12">' +
                '<i class="fa {{icon}} fa-5x"></i>' +
                '</div>' +
                '</div>' +
                '</div>' +

                '<div class="panel-footer text-center">' +
                '{{footer}}' +
                '<div class="clearfix"></div>' +
                '</div>' +

                '</div>' +
                '</a>' +
                '</div>',
            restrict: 'EA',
            compile: compile
        };
        return directive;

        function compile(element, attrs) {
            if (!attrs.footer) { attrs.footer = attrs.title;  }
            if (!attrs.color) { attrs.color = "primary"; }
            
            if (!attrs.backgroundcolor) { attrs.backgroundcolor = attrs.color };
        }

    }
})();
